module.exports = __webpack_public_path__ + "static/media/login-burger.0b7ebcc3.png";